// src/components/juliette/GoToPageButton.tsx
// Bouton de repli affiche sous une reponse de Juliette quand elle renvoie l'agent
// vers une page (marqueur [GOTO:/route] -> cf src/lib/juliette-goto.ts).
//
// La navigation est deja automatique en fin de tour : ce bouton sert a y REVENIR
// si l'agent a navigue ailleurs entre-temps. Il est donc secondaire, pas primaire,
// d'ou le style discret (contour, pas de fond plein comme AddToCalendarButton).
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { routeLabel } from "@/lib/juliette-goto";

export function GoToPageButton({ route }: { route: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(route)}
      className="mt-1.5 inline-flex items-center gap-1.5 rounded-full border border-primary/40 px-3 py-1.5 text-xs font-medium text-primary transition-colors hover:bg-primary/10"
    >
      <ArrowRight className="h-3.5 w-3.5" />
      Revenir sur {routeLabel(route)}
    </button>
  );
}
